<template>
  <div class="col responsive-width">
    <div class="container-fluid">
      <div class="content">
        <div class="headers d-flex">
          <div>
            <h1 class="mb-0">{{ $t('invoices') }}</h1><span>{{ $t('fortnox_finans_invoices') }}</span>
          </div>
          <!--          <router-link :to="{ name : 'createInvoice' }" class="ms-auto">-->
          <!--            <svg width="31" height="30" viewbox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">-->
          <!--              <path-->
          <!--                  d="M22.6541 0C27.7541 0 30.6641 2.88 30.6641 7.995V22.005C30.6641 27.09 27.7691 30 22.6691 30H8.65906C3.54406 30 0.664062 27.09 0.664062 22.005V7.995C0.664062 2.88 3.54406 0 8.65906 0H22.6541ZM15.6491 8.265C14.9591 8.265 14.4041 8.82 14.4041 9.51V13.74H10.1591C9.82906 13.74 9.51406 13.875 9.27406 14.1C9.04906 14.34 8.91406 14.6535 8.91406 14.985C8.91406 15.675 9.46906 16.23 10.1591 16.245H14.4041V20.49C14.4041 21.18 14.9591 21.735 15.6491 21.735C16.3391 21.735 16.8941 21.18 16.8941 20.49V16.245H21.1541C21.8441 16.23 22.3991 15.675 22.3991 14.985C22.3991 14.295 21.8441 13.74 21.1541 13.74H16.8941V9.51C16.8941 8.82 16.3391 8.265 15.6491 8.265Z"-->
          <!--                  fill="#7754FB"></path>-->
          <!--            </svg>-->
          <!--          </router-link>-->
        </div>
        <nav>
          <div class="row">
            <div class="col">
              <ul class="list-unstyled d-flex">
                <li @click="getInvoiceFortnox" class="all">{{ $t('all') }}</li>
                <li @click="filterInvoices('status=OPEN')" class="open">{{ $t('open') }}</li> 
                <li @click="filterInvoices('status=PAUSED')" class="paused">{{ $t('paused') }}</li>
                <li @click="filterInvoices('status=CLOSED')" class="closed">{{ $t('closed') }}</li>
              </ul>
            </div>
            <div class="col">
              <div class="right-parent">
                <!-- <div class="filter">
                  <label>{{ $t("filter") }}</label>
                  <select>
                    <option value="all">{{ $t("all") }}</option>
                  </select>
                  <button type="submit">{{ $t("applyFilter") }}</button>
                </div> -->
                <div class="d-flex flex-wrap align-items-center">
                  <div class="search">
                    <label for="search">
                      <svg width="15" height="15" viewbox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.6219 13.5596L10.0568 8.99453C10.7652 8.07871 11.1484 6.95898 11.1484 5.78125C11.1484 4.37148 10.5982 3.04961 9.60332 2.05293C8.6084 1.05625 7.28301 0.507812 5.875 0.507812C4.46699 0.507812 3.1416 1.05801 2.14668 2.05293C1.15 3.04785 0.601562 4.37148 0.601562 5.78125C0.601562 7.18926 1.15176 8.51465 2.14668 9.50957C3.1416 10.5063 4.46523 11.0547 5.875 11.0547C7.05273 11.0547 8.1707 10.6715 9.08652 9.96484L13.6516 14.5281C13.6649 14.5415 13.6808 14.5521 13.6983 14.5594C13.7158 14.5666 13.7346 14.5704 13.7535 14.5704C13.7725 14.5704 13.7912 14.5666 13.8087 14.5594C13.8262 14.5521 13.8421 14.5415 13.8555 14.5281L14.6219 13.7635C14.6353 13.7501 14.6459 13.7342 14.6531 13.7167C14.6604 13.6992 14.6641 13.6805 14.6641 13.6615C14.6641 13.6426 14.6604 13.6238 14.6531 13.6063C14.6459 13.5889 14.6353 13.573 14.6219 13.5596ZM8.65938 8.56563C7.91406 9.30918 6.92617 9.71875 5.875 9.71875C4.82383 9.71875 3.83594 9.30918 3.09063 8.56563C2.34707 7.82031 1.9375 6.83242 1.9375 5.78125C1.9375 4.73008 2.34707 3.74043 3.09063 2.99688C3.83594 2.25332 4.82383 1.84375 5.875 1.84375C6.92617 1.84375 7.91582 2.25156 8.65938 2.99688C9.40293 3.74219 9.8125 4.73008 9.8125 5.78125C9.8125 6.83242 9.40293 7.82207 8.65938 8.56563Z"
                            fill="#8F8E94"></path>
                      </svg>
                    </label>
                    <input @input="searchField" id="search" type="text" :placeholder="$t('search')">
                  </div>
                  <!--                  <div class="customize p-2"><a class="d-flex" href="javascript:void(0);">-->
                  <!--                    <svg width="14" height="13" viewbox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                  <!--                      <path-->
                  <!--                          d="M5.83724 7.2474H1.58724C1.39938 7.2474 1.21921 7.32202 1.08637 7.45486C0.953534 7.5877 0.878906 7.76787 0.878906 7.95573V12.2057C0.878906 12.3936 0.953534 12.5738 1.08637 12.7066C1.21921 12.8394 1.39938 12.9141 1.58724 12.9141H5.83724C6.0251 12.9141 6.20527 12.8394 6.33811 12.7066C6.47094 12.5738 6.54557 12.3936 6.54557 12.2057V7.95573C6.54557 7.76787 6.47094 7.5877 6.33811 7.45486C6.20527 7.32202 6.0251 7.2474 5.83724 7.2474ZM5.12891 11.4974H2.29557V8.66406H5.12891V11.4974ZM12.9206 0.164062H8.67057C8.48271 0.164063 8.30254 0.23869 8.16971 0.371528C8.03687 0.504367 7.96224 0.684534 7.96224 0.872396V5.1224C7.96224 5.31026 8.03687 5.49042 8.16971 5.62326C8.30254 5.7561 8.48271 5.83073 8.67057 5.83073H12.9206C13.1084 5.83073 13.2886 5.7561 13.4214 5.62326C13.5543 5.49042 13.6289 5.31026 13.6289 5.1224V0.872396C13.6289 0.684534 13.5543 0.504367 13.4214 0.371528C13.2886 0.23869 13.1084 0.164063 12.9206 0.164062ZM12.2122 4.41406H9.37891V1.58073H12.2122V4.41406ZM12.9206 9.3724H11.5039V7.95573C11.5039 7.76787 11.4293 7.5877 11.2964 7.45486C11.1636 7.32202 10.9834 7.2474 10.7956 7.2474C10.6077 7.2474 10.4275 7.32202 10.2947 7.45486C10.1619 7.5877 10.0872 7.76787 10.0872 7.95573V9.3724H8.67057C8.48271 9.3724 8.30254 9.44702 8.16971 9.57986C8.03687 9.7127 7.96224 9.89287 7.96224 10.0807C7.96224 10.2686 8.03687 10.4488 8.16971 10.5816C8.30254 10.7144 8.48271 10.7891 8.67057 10.7891H10.0872V12.2057C10.0872 12.3936 10.1619 12.5738 10.2947 12.7066C10.4275 12.8394 10.6077 12.9141 10.7956 12.9141C10.9834 12.9141 11.1636 12.8394 11.2964 12.7066C11.4293 12.5738 11.5039 12.3936 11.5039 12.2057V10.7891H12.9206C13.1084 10.7891 13.2886 10.7144 13.4214 10.5816C13.5543 10.4488 13.6289 10.2686 13.6289 10.0807C13.6289 9.89287 13.5543 9.7127 13.4214 9.57986C13.2886 9.44702 13.1084 9.3724 12.9206 9.3724ZM5.83724 0.164062H1.58724C1.39938 0.164063 1.21921 0.23869 1.08637 0.371528C0.953534 0.504367 0.878906 0.684534 0.878906 0.872396V5.1224C0.878906 5.31026 0.953534 5.49042 1.08637 5.62326C1.21921 5.7561 1.39938 5.83073 1.58724 5.83073H5.83724C6.0251 5.83073 6.20527 5.7561 6.33811 5.62326C6.47094 5.49042 6.54557 5.31026 6.54557 5.1224V0.872396C6.54557 0.684534 6.47094 0.504367 6.33811 0.371528C6.20527 0.23869 6.0251 0.164063 5.83724 0.164062ZM5.12891 4.41406H2.29557V1.58073H5.12891V4.41406Z"-->
                  <!--                          fill="#5855D6"></path>-->
                  <!--                    </svg>-->
                  <!--                    Customize</a></div>-->
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div class="box">
          <div class="box-responsive">
            <table>
              <thead>
              <tr>
                <th>
                  <div class="checkbox">
                    <input type="checkbox">
                    <svg width="21" height="20" viewbox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1.28201" y="0.664818" width="18.5834" height="18.5834" rx="3.42325" fill="#5855D6"
                            stroke="#5855D6" stroke-width="0.978073"></rect>
                      <path
                          d="M14.8057 5.95575C15.0124 5.75899 15.2874 5.65022 15.5727 5.65238C15.8581 5.65453 16.1314 5.76746 16.3351 5.96732C16.5387 6.16718 16.6568 6.43834 16.6643 6.72359C16.6719 7.00884 16.5683 7.28587 16.3755 7.49621L10.5217 14.8171C10.4211 14.9255 10.2996 15.0125 10.1645 15.0729C10.0295 15.1333 9.88365 15.1658 9.73574 15.1686C9.58782 15.1713 9.44087 15.1442 9.30368 15.0888C9.16648 15.0335 9.04186 14.951 8.93726 14.8464L5.05529 10.9645C4.94718 10.8637 4.86047 10.7422 4.80033 10.6073C4.74019 10.4723 4.70786 10.3266 4.70525 10.1789C4.70264 10.0311 4.72982 9.88435 4.78516 9.74734C4.8405 9.61033 4.92287 9.48587 5.02736 9.38139C5.13184 9.2769 5.2563 9.19453 5.39331 9.13919C5.53033 9.08385 5.67708 9.05667 5.82482 9.05928C5.97256 9.06189 6.11827 9.09422 6.25324 9.15436C6.38821 9.2145 6.50969 9.30121 6.61042 9.40932L9.68255 12.48L14.7778 5.98802C14.787 5.97673 14.7968 5.96595 14.8072 5.95575H14.8057Z"
                          fill="#F6F8FC"></path>
                    </svg>
                  </div>
                </th>
                <th v-for="(item, i) in tableHeader" :key="i">
                  <span>{{ $services.helpers.removeUnderscoreAndCapString($t(item)) }}</span></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,key) in GET_INVOICE_FORTNOX.results" :key="key">
                <FortnoxInvoiceTable
                    :data="item"
                    :head="tableHeader"
                />
              </tr>

              </tbody>
            </table>
          </div>
          <div v-if="loading" class="d-flex justify-content-center">
            <div class="loader">{{ $t("loading") }}</div>
          </div>
          <div v-if="!loading && GET_INVOICE_FORTNOX.results && GET_INVOICE_FORTNOX.results.length < 1"
               class="d-flex justify-content-center p-2">
            <small>No Fortnox invoice available</small>
          </div>
        </div>
        <div class="actions d-flex align-items-center">
          <label>{{ $t('actions') }}</label>
          <select v-model="action">
            <option value="pause">{{ $services.helpers.capitalizeNames($t('paused')) }}</option>
            <option value="stop">{{ $services.helpers.capitalizeNames($t('stop')) }}</option>
          </select>
          <button type="button" v-on:click="processNoxFinansAction">
            <span v-if="processing === false">{{ $t('apply') }}</span>
            <span v-else>{{ $t('processing') }}...</span>
          </button>
          <div class="d-flex justify-content-end w-full">
            <v-pagination
                v-model="GET_INVOICE_FORTNOX.page"
                :pages="GET_INVOICE_FORTNOX.total_pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="changePageNumber"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalBoxVue v-if="openPauseForm" @handleClose="openPauseForm = false" :close="!true">
    <div class="popup-box">
      <h4 style="text-align:left !important">{{$t('pause_invoice')}}</h4>
      <div class="p-3">
        <div class="desc" style="display: flex;justify-content: space-between;margin-bottom: 15px;">
          <label>{{$t('pause_until')}}</label>
          <Datepicker v-model="pause_until"
                      format="dd-MM-yyyy"></Datepicker>
        </div>
        <div class="desc">
          <button @click="pauseNoxInvoice" :disabled='pauseProcessing' type="button">
            <span v-if="pauseProcessing">Saving...</span>
            <span v-else>Pause</span>
          </button>
        </div>
      </div>
    </div>
  </ModalBoxVue>
</template>

<script>
import {mapGetters} from 'vuex'
import debounce from 'lodash.debounce'
import FortnoxInvoiceTable from './reusableComponents/FortnoxInvoiceTable.vue'
import VPagination from '@hennge/vue3-pagination'
import '@hennge/vue3-pagination/dist/vue3-pagination.css'
import ModalBoxVue from '../../components/ModalBox.vue'
import Datepicker from 'vue3-date-time-picker';
import moment from 'moment'

export default {
  name: 'InvoiceFortnox',
  components: {FortnoxInvoiceTable, VPagination, ModalBoxVue, Datepicker},
  data() {
    return {
      tableHeader: ['invoice_number', 'customer_number', 'customer_name', 'invoice_date', 'invoice_amount', 'due_date', 'status',
        'next_event', 'next_event_date'],
      page: 1,
      loading: true,
      filter: null,
      action: '',
      processing: false,
      pauseProcessing: false,
      openPauseForm: false,
      pause_until: ''
    }
  },
  computed: {
    ...mapGetters({
      GET_INVOICE_FORTNOX: 'clients/GET_INVOICE_FORTNOX',
      GET_INVOICE_FORTNOX_CHECKED: 'clients/GET_INVOICE_FORTNOX_CHECKED',
      CURRENT_USER: 'clients/GET_CURRENT_USER'
    })
  },
  mounted() {
    this.getInvoiceFortnox()
    // this.getInvoiceCustomizeHeader()
  },
  methods: {
    searchField: debounce(function (event) {
      if (event.target.value !== '') {
        this.filterSearch(event.target.value)
      } else {
        this.getInvoiceFortnox()
      }
    }, 500),
    filterSearch(data) {
      const payload = `search=${data}`
      this.$store.commit('clients/UPDATE_INVOICE_FORTNOX', [])
      this.filter = payload
      this.$store.dispatch('clients/getInvoiceFortnox', payload)
    },
    changePageNumber(number) {
      if (number !== this.page) {
        let payload = ''
        if (this.filter) {
          payload = `page=${number}&${this.filter}`
        } else {
          payload = `page=${number}`
        }
        this.$store.commit('clients/UPDATE_INVOICE_FORTNOX', [])
        this.$store.dispatch('clients/getInvoiceFortnox', payload)
        this.page = number
      }
    },
    filterInvoices(data) {
      let payload = ''

      // if (data === 'unpaid') {
      //     payload = 'booked=True&fully_paid=False'
      // }
      // this.$store.commit('clients/UPDATE_INVOICE_FORTNOX', [])
      this.$store.dispatch('clients/getInvoiceFortnox', data)
    },
    getInvoiceFortnox() {
      this.loading = true
      this.$store.dispatch('clients/getInvoiceFortnox', null)
          .then(_ => {
            this.loading = false
          })
          .catch(_ => {
            this.loading = false
          })
    },
    getInvoiceCustomizeHeader() {
      this.$store.dispatch('clients/getInvoiceCustomizeHeader')
          .then(res => {
            this.tableHeader = res.data.data
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.$store.commit('auth/CLEAR_AUTH_USER', null)
              window.Bus.emit('logout')
            }
          })
    },
    pauseNoxInvoice: function () {
      if (this.CURRENT_USER.access === 'Read') {
        return this.$toast.info(this.$t('limited_read_access'));
      }
      let checked = []
      this.GET_INVOICE_FORTNOX_CHECKED.data.map(item => {
        if (!checked.includes(item.invoice_number)) {
          checked.push(item.invoice_number)
        }
      })
      this.pauseProcessing = true
      if (this.pause_until === '') {
        this.pauseProcessing = false
        // return this.$services.helpers.notification('kindly supply a valid date', 'error', this)
        return this.$toast.error(this.$t('invalid_date'));
      }
      this.$store.dispatch('clients/updateBulkNoxFinanceAction', {
        'action': 'pause',
        'invoices': checked,
        'paused_until_date': moment(this.pause_until).format('YYYY-MM-DD')
      }).then(res => {
        this.pauseProcessing = false
        this.openPauseForm = false
        this.GET_INVOICE_FORTNOX_CHECKED.data.map(item => {
          item.checked = false
        })
        //
        if ('failed' in res.data) {
          if (res.data.failed.length > 0) {
            this.$services.helpers.notification(res.data.failed, 'error', this)
          } else {
            // this.$services.helpers.notification('Nox finans paused successfully', 'success', this)
            this.$toast.success(this.$t('noxs_paused'));
          }
        } else {
          // this.$services.helpers.notification('Nox finans paused successfully', 'success', this)
          this.$toast.success(this.$t('noxs_paused'));
        }
      }).catch(err => {
        this.pauseProcessing = false
        this.$services.helpers.notification(err.response.data.message, 'error', this)
      })
    },
    processNoxFinansAction: function () {
      if (this.CURRENT_USER.access === 'Read') {
        return this.$toast.info(this.$t('limited_read_access'));
      }
      if (this.GET_INVOICE_FORTNOX_CHECKED.data.length === 0) {
        // return this.$services.helpers.notification('Kindly check one or more nox finans invoice', 'error', this)
        return this.$toast.warning(this.$t('choose_invoice'));
      }
      if (this.action === 'pause') {
        this.openPauseForm = true
      } else if (this.action === 'stop') {
        let checked = []

        this.GET_INVOICE_FORTNOX_CHECKED.data.map(item => {
          if (!checked.includes(item.invoice_number)) {
            checked.push(item.invoice_number)
          }
        })
        this.processing = true
        this.$store.dispatch('clients/updateBulkNoxFinanceAction', {
          'action': 'stop',
          'invoices': checked
        }).then(res => {
          this.processing = false
          this.GET_INVOICE_FORTNOX_CHECKED.data.map(item => {
            item.checked = false
          })
          if ('failed' in res.data) {
            this.$services.helpers.notification(res.data.failed, 'error', this)
          } else {
            // this.$services.helpers.notification('Nox finans stopped successfully', 'success', this)
            this.$toast.success(this.$t('noxs_stopped'));
          }

        }).catch(err => {
          this.processing = false
          this.$services.helpers.notification(err.response.data.message, 'error', this)
        })

      }
    }
  },
}
</script>

<style lang="scss" scoped>
.dp__input_icon_pad {
  width: 100% !important
}

.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content .headers {
  margin: 30px 0 10px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.content .headers h1 {
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #333269;
}

.content .headers h1 ~ span {
  font-size: 16px;
  line-height: 24px;
  color: #333269;
}

.content .headers a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .headers a:hover svg path {
  fill: #4946ae;
}

.content nav {
  margin: 20px 0 0 5px;
}

@media (max-width: 1094px) {
  .content nav .row {
    display: block;
  }
  .content nav .row > div:last-of-type {
    margin-top: 10px;
  }
  .content nav .row ul {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .content nav .row ul li {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

.content nav ul {
  margin: 0;
  text-align: center;
}

.content nav ul li {
  border-radius: 3.24215px;
  font-size: 11.3475px;
  line-height: 26px;
  color: #ffffff;
  cursor: pointer;
  width: 81.05px;
  height: 26.11px;
  -webkit-transition: color 0.3s ease-in-out, -webkit-transform 0.35s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, -webkit-transform 0.35s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;
  -o-transition: color 0.3s ease-in-out, transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out;
  transition: color 0.3s ease-in-out, transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out, -webkit-transform 0.35s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;
}

.content nav ul li:hover {
  -webkit-transform: translateY(-0.25em);
  -ms-transform: translateY(-0.25em);
  transform: translateY(-0.25em);
}

.content nav ul li.all {
  background: #c0beff;
}

.content nav ul li.all:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
  box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
}

.content nav ul li.open {
  background: #4d82f3;
}

.content nav ul li.open:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #4d82f3;
  box-shadow: 0 0.5em 0.5em -0.1em #4d82f3;
}

.content nav ul li.paused {
  background: #efb008;
  color: #976400;
}

.content nav ul li.paused:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #efb008;
  box-shadow: 0 0.5em 0.5em -0.1em #efb008;
}

.content nav ul li.closed {
  background: #a5e1bf;
  color: #00632b;
}

.content nav ul li.closed:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #a5e1bf;
  box-shadow: 0 0.5em 0.5em -0.1em #a5e1bf;
}

.content nav ul li:not(:last-of-type) {
  margin-right: 15px;
}

.content nav .right-parent {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (min-width: 1097px) {
  .content nav .right-parent {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
}

.content nav .right-parent .filter {
  margin-right: 20px;
}

.content nav .right-parent .filter label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content nav .right-parent .filter select {
  margin: 0 10px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content nav .right-parent .filter select:focus {
  outline: none;
}

.content nav .right-parent .filter button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content nav .right-parent .filter button:hover {
  background-color: #4947b0;
  color: #fff;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .filter {
    margin-top: 10px;
  }
}

@media (max-width: 575.98px) {
  .content nav .right-parent .filter {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .content nav .right-parent .filter * {
    margin: 5px !important;
  }
}

.content nav .right-parent .search {
  margin-right: 10px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width:207.5px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .search {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .search {
    margin: 10px 0 0;
  }
}

.content nav .right-parent .search label {
  position: absolute;
  left: 0.5rem;
}

.content nav .right-parent .search input {
  border: none;
  width: 77%;
  margin-left: auto;
}

.content nav .right-parent .search input:focus {
  outline: none;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .customize {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .customize {
    -webkit-flex-basis: 100%;
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
  }
}

.content nav .right-parent .customize a {
  font-size: 14px;
  line-height: 22px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #5855d6;
  text-decoration: none;
  -webkit-transition: color 0.4s ease-out;
  -o-transition: color 0.4s ease-out;
  transition: color 0.4s ease-out;
}

.content nav .right-parent .customize a svg {
  margin-right: 10px;
}

.content nav .right-parent .customize a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content nav .right-parent .customize a:hover {
  color: #4946ae;
}

.content nav .right-parent .customize a:hover svg path {
  fill: #4946ae;
}

.content .box {
  background: #ffffff;
  -webkit-box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2), 0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2), 0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  border-radius: 3.91229px;
  margin-top: 20px;
}

.content .box table {
  width: 100%;
  text-align: center;
  min-width: 970px;
}

.content .box table .checkbox {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.content .box table .checkbox input {
  border: 0.978073px solid #64748b;
  border-radius: 3.91229px;
  height: 15px;
  width: 15px;
  position: relative;
  z-index: 33;
  background: #fffbfb;
  cursor: pointer;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table .checkbox input:checked {
  border: none;
  background: transparent;
}

.content .box table .checkbox input,
.content .box table .checkbox input:checked {
  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
}

.content .box table .checkbox input:checked ~ svg {
  display: block;
}

.content .box table .checkbox svg {
  position: absolute;
  height: 17px;
  width: 17px;
  display: none;
  z-index: 1;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table thead {
  border-bottom: 0.978073px solid #cbd4e1;
}

.content .box table thead th {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  padding-top: 20px;
  padding-bottom: 20px;
}

.content .box table thead th:first-of-type {
  padding-left: 10px;
}

.content .box table thead th:last-of-type {
  padding-right: 10px;
}

.content .box table thead th span {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}

.content .box table tbody tr {
  -webkit-transition: background 0.2s ease-out;
  -o-transition: background 0.2s ease-out;
  transition: background 0.2s ease-out;
}

.content .box table tbody tr:hover {
  background-color: #f8fbff !important;
}

.content .box table tbody tr:nth-child(odd) {
  background: #f1f4f9;
}

.content .box table tbody td {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .box table tbody td a {
  text-decoration: none;
  display: block;
  color: #000;
  padding: 10px 5px;
}

.content .box table tbody td:first-of-type {
  padding-left: 10px;
}

.content .box table tbody td span {
  border-radius: 4px;
  width: 79.24px;
  height: 21.26px;
  display: block;
  text-align: center;
  font-weight: 500;
  font-size: 11.5959px;
  line-height: 21.26px;
  margin: 0 auto;
}

.content .box table tbody td span.open {
  background: #4d82f3;
  color: #ffffff;
}

.content .box table tbody td span.paused {
  background: #efb008;
  color: #976400;
}

.content .box table tbody td span.closed {
  background: #a5e1bf;
  color: #00632b;
}

.content .box table tbody td button {
  background: transparent;
  border: none;
  padding: 0;
}

.content .box table tbody td button:not(:last-of-type) {
  margin-right: 10px;
}

.content .box table tbody tr.booked td {
  color: #4d82f3;
}

.content .box table tbody tr.booked td button:nth-child(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.notbooked td {
  color: #efb008;
}

.content .box table tbody tr.notbooked td:not(:last-of-type) path {
  fill: #64748b;
}

.content .box table tbody tr.unpaid td {
  color: #fb4b4b;
}

.content .box table tbody tr.unpaid td button:nth-child(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.fullypaid td {
  color: #419e6a;
}

.content .box table tbody tr.fullypaid td button:nth-child(1),
.content .box table tbody tr.fullypaid td button:nth-child(2) {
  opacity: 0.5;
  pointer-events: none;
}

.content .box table tbody tr.voided td {
  color: #64748b;
}

.content .box table tbody tr.voided td:not(:last-of-type) path {
  fill: #64748b;
}

.content .actions {
  margin-top: 30px;
  margin-bottom: 20px;
}

.content .actions label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .actions select {
  margin: 0 15px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content .actions select:focus {
  outline: none;
}

.content .actions button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .actions button:hover {
  background-color: #4947b0;
  color: #fff;
}

button:hover {
  background-color: #4947b0;
  color: #fff;
}
</style>